import { jsx } from "react/jsx-runtime";
import { Icon } from "../MainIcon/MainIcon.js";
import "@mui/material";
const CalendarEventIcon = ({ size = "md", ...rest }) => {
  return /* @__PURE__ */ jsx(Icon, { size, ...rest, children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.98438 1.98633C6.7195 1.99047 6.46709 2.09953 6.28254 2.28957C6.09799 2.47962 5.99637 2.73512 6 3V4H5C3.90694 4 3 4.90694 3 6V20C3 21.0931 3.90694 22 5 22H19C20.0931 22 21 21.0931 21 20V6C21 4.90694 20.0931 4 19 4H18V3C18.0018 2.86621 17.9768 2.73341 17.9264 2.60947C17.876 2.48553 17.8012 2.37297 17.7065 2.27845C17.6118 2.18393 17.4991 2.10937 17.375 2.05919C17.251 2.00902 17.1182 1.98424 16.9844 1.98633C16.7195 1.99047 16.4671 2.09953 16.2825 2.28957C16.098 2.47962 15.9964 2.73512 16 3V4H8V3C8.00183 2.86621 7.9768 2.73341 7.92638 2.60947C7.87597 2.48553 7.80119 2.37297 7.70649 2.27845C7.61179 2.18393 7.49908 2.10937 7.37504 2.05919C7.25101 2.00902 7.11816 1.98424 6.98438 1.98633ZM5 9H19V20H5V9ZM13 13C12.448 13 12 13.448 12 14V17C12 17.552 12.448 18 13 18H16C16.552 18 17 17.552 17 17V14C17 13.448 16.552 13 16 13H13Z",
      fill: rest.fill
    }
  ) });
};
export {
  CalendarEventIcon
};
